export default {
    ensureSSLImage: (imageURL: string | null): string => {
        if (!imageURL) {
            return "";
        }
        return imageURL.replace(/http.*url=/, "https://images-eds-ssl.xboxlive.com/image?url=");
    }
};
